import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { NuevoViajeRutaModelEdit} from "./../../viajes/edit/items/index";

//module "c:/Users/IrvingNavarro/Downloads/uruz2/2222/azymo/Logistica/AspWebApi/app/features/general/"
//"operativa/items/viajes/edit/items/index"


type Entity = models.ManifiestoRADDto;
import { columnas } from "./columns";
const resource = resources.ManifiestoRAD;

interface Props {
    permisos: models.Rol;
    HabilitarValidacionesCartaPorte : boolean;
}

export interface PropsModal extends kea.ModalProps<Entity, boolean, undefined> {
}

class ManifiestoListNoRX extends React.PureComponent<Props> {
    items = observeResource(resource.Consultar, {} as models.FiltroManifiestosRAD);
    modalManager = kea.createModalManager();

    onVer = (x: Entity) => {
        history.go("./" + x.IdRegistro);
    }

    onCancelar = async (x: Entity) => {
        if (await kea.yesno("¿Cancelar manifiesto " + x.Folio + "?")) {
            await resource.CancelarManifiesto(x.IdRegistro);
            await kea.message("Manifiesto cancelado", "Folio: " + x.Folio, "success");
        }
    }

    onTerminar = async (x: Entity) => {

        //const result = await this.modalManager.showModal(NuevoViajeRutaModelEdit, undefined, {} as models.NuevoViajeRutaModel);
        //const model = await this.modalNuevoViaje();
        
        if (await kea.yesno("¿Marcar como terminado la recolección con folio " + x.Folio + "?")) {
            await resource.TerminarManifiesto(x.IdRegistro);
            await kea.message("Recolección terminada", "Folio: " + x.Folio, "success");
        }
    }

    onImprimir = async (x: Entity) => {
        const data = await resource.ImprimirManifiesto(x.IdRegistro);
        await kea.printPdf(data);
    }

    onAgregar = async () => {
        history.go("./new");
    }

    onTimbrarCartaPorteRAD = async (x: Entity) => {
        if (await kea.yesno(`¿timbrar carta por del viaje ${x.Folio} ?`)) {

            var xml = await resources.Factura.TimbrarCartaPorteRAD(x.IdRegistro);
            kea.download(kea.base64ToBlob(xml, 'application/xml'), "CartaPorteRAD"+ x.Folio + ".xml");
            if  (!x.TieneXmlTimbrado)
            location.reload();
        }
    }

    onImprimirCartaPorteRAD = async (x: Entity) => {
        if (await kea.yesno(`¿Imprimir pdf de carta porte del viaje ${x.Folio} ?`)) {
            var PdfCartaPorte = await resources.Factura.ImprimirPdfRAD(x.IdRegistro);
            //kea.printPdf(PdfCartaPorte);

            kea.download(kea.base64ToBlob(PdfCartaPorte, 'application/pdf'), "CartaPorteRAD"+ x.Folio + ".pdf");
            if  (!x.TienexmlImpreso)
            location.reload();
        }
    }

    onRegresar = () => history.go("../");

    permisosUsuario = (props: Props) => props.permisos;

    HabilitarValidacionesCartaPorte = (props: Props) => props.HabilitarValidacionesCartaPorte;


    modalNuevoViaje = async () => {
        const result = await this.modalManager.showModal(NuevoViajeRutaModelEdit, undefined, {} as models.NuevoViajeRutaModel);
        if (result.result) {
            return result.value;
        } else {
            return undefined;
        }
    }

    render() {
        const permisosUsuario = this.permisosUsuario(this.props);
        const HabilitarValidacionesCartaPorte = this.HabilitarValidacionesCartaPorte(this.props);

        const cols = columnas(this, permisosUsuario, HabilitarValidacionesCartaPorte);

        return (
            <div>
                <kea.Title titulo="Manifiestos de RAD" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"ListCookieKey"} items={this.items} />
            </div>
        )
    }
}

const ManifiestoListRX = componentToRx(ManifiestoListNoRX);

export class ManifiestoList extends React.PureComponent {

    HabilitarValidacionesCartaPorte = observeResource(resources.ConfigSistema.HabilitarValidacionesCartaPorte);

    render() {
        return (
            <ManifiestoListRX permisos={resources.User.PermisoRx}  HabilitarValidacionesCartaPorte={ this.HabilitarValidacionesCartaPorte } />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/manifiestorad/list/list.tsx